module.exports = __webpack_public_path__ + "media/images/country_flags/zm-32c6f2785826b8f4ab433e46d19a3849.png";